import React, { Component } from 'react';
import { WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Typography, Button } from '@material-ui/core';
import ListItem from '@material-ui/core/ListItem';
import { MyPATLink } from '../../common';
import _ from 'lodash';
import cx from 'classnames';
import CourseDetailsDrawer from '../components/CourseDetailsDrawer';
import courseService from '../services/courseService';
import { showMsg } from '../actions/loaderAlert';
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';
import { setCourseData } from '../actions/courseSetData';
import {styles} from '../styling/CourseTemplate'
import {CourseBasicInfo,CourseDetailDefault} from '../modals/CourseBasicInfo';

interface CourseTemplateProps extends WithStyles<typeof styles> {
    match: any;
    showMsg: (msg: string, vari: string) => void,
    detailsData: CourseBasicInfo,
    setCourseData: Function;
}

interface CourseTemplateStates {
    hasContent: Boolean,
    courseTemplatesData: CourseBasicInfo[],
    isDetailDrawerOpen: Boolean,
    detailsData: CourseBasicInfo
}

class CourseTemplate extends Component<CourseTemplateProps, CourseTemplateStates> {
    constructor(props: CourseTemplateProps) {
        super(props);
        this.state = {
            hasContent: true,
            courseTemplatesData: [],
            isDetailDrawerOpen: false,
            detailsData: CourseDetailDefault
        };
        this.handleDetailDrawerOpen = this.handleDetailDrawerOpen.bind(this);
        this.handleDetailDrawerClose = this.handleDetailDrawerClose.bind(this);
        this.refreshState = this.refreshState.bind(this);
    }

    handleDetailDrawerOpen = (event: any, details: any) => {
        event.preventDefault();
        courseService.getPackageDetails(details._id).then((details: CourseBasicInfo) => {
            this.setState({
                isDetailDrawerOpen: true,
                detailsData: details
            });
        });
    };

    refreshState(event: any, details: any) {
        this.props.setCourseData(details)
        setTimeout(function () {
            window.location.href = `/course/detail/${details._id}`;
        }, 1000)

    }


    handleDetailDrawerClose = (event: any) => {

        this.setState({
            isDetailDrawerOpen: false,
        });
    };


    componentWillMount() {
        courseService.getCourseTemplates().then((courseTemplates: CourseBasicInfo[]) => {
            var self = this;
            self.setState({ courseTemplatesData: courseTemplates })
        });
    }

	render() {
		let { classes } = this.props;
        let { courseTemplatesData } = this.state;
        courseTemplatesData = courseTemplatesData || []

		return (
			<>	
				<Grid container
					spacing={0}
					direction="column"
					className={classes.root}>
					<Grid item xs={12} className={classes.wrapperMain} style={{ marginTop: "20px" }}>
						
							<Grid xs={12}
								container
								direction="row"
								alignContent="center"
								justify="space-between"
							>
								<Grid xs={4}>
									<Typography variant="h6" style={{ padding: "10px" }}>
										Course Templates
								</Typography>
								</Grid>
								<Grid xs={12}>
									<div key={1}>
											{
												courseTemplatesData.map((value: any, index: any) => {
													return <ListItem className={classes.borderDefault}>
														<Grid item xs={12} container className={classes.leftDisplay}>
															<Grid item xs={8} >
																<Grid item xs={12}>
																	<Typography variant="h6" className={cx(classes.textEllipsis)}>{value.name}</Typography>
																</Grid>
																<Grid item xs={12}>
																	<Typography variant="caption" className={classes.subTitle}>
																	{value.milestones.length + " Milestones, "} {value.subMilestones.length + " Sub Milestones, "} {value.revisionMilestones.length + " Revision Milestones"}
																	</Typography>
																</Grid>
															</Grid>
															<Grid item xs={4}>
																<Grid item xs={12} className={classes.previewBtn}>
																	<div className="content-preview">
																			<Button   onClick={(e: any) => this.refreshState(e, value)}  variant="contained" size="medium" className={classes.previewButton}>
																				Select
																			</Button>
																		<br />
																		<MyPATLink to="" onClick={(e: any) => this.handleDetailDrawerOpen(e, value)} displayProp="inline-block" className={classes.viewDetails}> View Detail
												</MyPATLink>
																	</div>
																</Grid>
															</Grid>
														</Grid>
													</ListItem>
												})
											}
									</div>
								</Grid>
					</Grid>
					<CourseDetailsDrawer
					onDetailDrawerClose={this.handleDetailDrawerClose.bind(this)}
					isDetailsDrawerOpen={this.state.isDetailDrawerOpen}
					drawerData = {this.state.detailsData}
				/>
				</Grid>
				</Grid>
			</>
		)
	}
}

const mapDispatchToProps = (dispatch: any) => bindActionCreators(
    {
        showMsg: showMsg,
        setCourseData: setCourseData
    },
    dispatch
);
// @ts-ignore
export default connect(null, mapDispatchToProps)(withStyles(styles)(CourseTemplate));